export interface fsInitialState {
  id: string;
  numItems: number;
  activeElementIndex: number;
  slideIndex: number;
  liClass: string;
  touchstartX: number;
  touchendX: number;
  isRtl: boolean;
  captionData: any;
  slidesData: any;
  wrapperWidth: string;
  isNext: boolean;
  isPrev: boolean;
  imageGap: number;
  transitionEffect: string;
  firstItemIndex: number;
  lastItemIndex: number;
  transitionDelay: boolean;
  fsDelay: boolean;
  isTransitionStarted: boolean;
  isSliding: boolean;
  startX: number;
  x: number;
  swiped: number;
  prevArrowAriaDisabled: boolean;
  nextArrowAriaDisabled: boolean;
  visible: number;
  mouseDown: boolean;
  isUsingKeyboard: boolean;
}

export const mobileDeviceTestRegex = /android|iphone|kindle|ipad/i;

export const isMobileDeviceUsed = () => {
  const userAgent = navigator.userAgent || '';
  return mobileDeviceTestRegex.test(userAgent);
};

export const cloneLoopedImages = (dataArr, start, end) => {
  return dataArr.slice(start, end).map(imgObj => {
    const modifiedImgObj = { ...imgObj };
    modifiedImgObj.isCloned = true;
    return modifiedImgObj;
  });
};

export const initFilmstripImages = $this => {
  const data = [...$this.stateObject.slidesData];
  const initialLoadedImgs = data.map((imgObj, index) => {
    const modifiedImgObj = { ...imgObj };
    modifiedImgObj.isCloned = false;
    modifiedImgObj.dataIndex = index;
    modifiedImgObj.isActive = index === 0;
    modifiedImgObj.role = 'listitem';
    modifiedImgObj.posInset = index + 1;
    return modifiedImgObj;
  });

  if (data.length > 1 && $this.loop) {
    const itemsToShow = 5;
    const prevListClonedImgs = cloneLoopedImages(data, data.length - itemsToShow, data.length);
    const nextListClonedImgs = cloneLoopedImages(data, 0, itemsToShow);

    const combinedImgsList = [...prevListClonedImgs, ...initialLoadedImgs, ...nextListClonedImgs];

    const clonedPosList = combinedImgsList.map((val, index) => {
      val.pos = index;
      if (val.dataIndex === 0) {
        $this.stateObject.firstItemIndex = index;
      }
      if (val.dataIndex === $this.stateObject.numItems - 1) {
        $this.stateObject.lastItemIndex = val.pos;
      }
      return {
        ...val,
      };
    });
    $this.stateObject.slidesData = clonedPosList;
    $this.stateObject.slideIndex = $this.stateObject.firstItemIndex;
  } else {
    $this.stateObject.slidesData = initialLoadedImgs;
  }
};

export const getListItemClass = (val, size) => {
  const s = size === 'small' ? 's' : 'l';
  switch (val) {
    case '2':
      return `vs-2-up-${s}`;
    case '3':
      return `vs-3-up-${s}`;
    default:
      return `vs-2-up-${s}`;
  }
};

export const setSwipedCordinates = (swipedCordinates, $this) => {
  if ($this.stateObject.isRtl) {
    $this.swiped = -swipedCordinates;
  } else {
    $this.swiped = swipedCordinates;
  }
  if (!$this.showNext) {
    $this.swiped = $this.stateObject.isRtl ? -swipedCordinates : swipedCordinates;
  }
};

export const getSlidingCordinates = e => {
  let slideX = 0;
  if (e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchstart') {
    const touches = e.touches;
    slideX = touches[0].clientX;
  } else {
    slideX = e.clientX;
  }
  return slideX;
};

export const handleSlideMove = (e, $this) => {
  if (!$this.stateObject.isSwiping) {
    return;
  }
  $this.stateObject.transitionEffect = 'none';
  e.preventDefault();
  $this.stateObject.x = getSlidingCordinates(e);
  const swipedCordinates = $this.stateObject.x - $this.stateObject.startX;
  setSwipedCordinates(swipedCordinates, $this);
};

export const handleSlideEnd = (e, $this) => {
  e.preventDefault();
  // if ($this.stateObject.isSwiping && e.button === 0) {
  //   const w = $this.fsWrapper.querySelector('ul').offsetWidth;
  //   const sX = getSlidingCordinates(e);
  //   $this.stateObject.startX = sX - w;
  // } else {
  $this.stateObject.transitionEffect = 'ease';
  if ($this.swiped < 0 && $this.showNext) {
    let thirdWidth = $this.fsWrapper.querySelector('.isActive').clientWidth / 3;
    if (Math.abs($this.swiped) >= thirdWidth) {
      $this.next();
    }
  }
  if ($this.swiped > 0 && $this.showPrev) {
    let thirdWidth = $this.fsWrapper.querySelector('.isActive').previousElementSibling.clientWidth / 3;
    if (Math.abs($this.swiped) >= thirdWidth) {
      $this.prev();
    }
  }
  $this.swiped = 0;
  // }
  $this.stateObject.isSwiping = false;
};

export const handleSlideCancel = (e, $this) => {
  e.preventDefault();
  $this.stateObject.isSwiping = false;
  $this.stateObject.startX = 0;
  $this.stateObject.transitionEffect = 'ease';
  if ($this.showNext) {
    $this.swiped = 0;
  }
};

export const handleNavigationKeys = (e, $this) => {
  if (e && e.which === 39) {
    $this.stateObject.isRtl ? $this.prev(true) : $this.next(true);
  }
  if (e && e.which === 37) {
    $this.stateObject.isRtl ? $this.next(true) : $this.prev(true);
  }
};

export const handleStartEvent = (e, $this) => {
  $this.stateObject.isSwiping = true;
  $this.stateObject.startX = getSlidingCordinates(e);
};

export const resetListElemAccessibility = $this => {
  const liArr = $this.fsWrapper.querySelectorAll('li');
  liArr.forEach(val => {
    val.ariaLabel = null;
    val.tabIndex = $this.loop ? '-1' : val?.tabIndex;
  });
};

export const handlePrevSlideLoop = ($this, currentActiveElem) => {
  const lastSelector = $this.fsWrapper.querySelector(`[data-index="${$this.stateObject.numItems - 1}"]`);
  const prevSibling = currentActiveElem.previousElementSibling;
  if (prevSibling && !prevSibling.classList.contains('isCloned')) {
    handleActiveElemSetting(prevSibling, $this);
    $this.stateObject.transitionDelay = false;
    $this.stateObject.transitionEffect = 'ease';
  } else {
    handleActiveElemSetting(lastSelector, $this, false);
    $this.stateObject.transitionDelay = true;
  }
};

export const handleNextSlideLoop = ($this, currentActiveElem) => {
  const nextSibling = currentActiveElem.nextElementSibling;
  const firstSelector = $this.fsWrapper.querySelector('[data-index="0"]');

  if (nextSibling && !nextSibling.classList.contains('isCloned')) {
    handleActiveElemSetting(nextSibling, $this);
    $this.stateObject.transitionDelay = false;
    $this.stateObject.transitionEffect = 'ease';
  } else {
    handleActiveElemSetting(firstSelector, $this);
    $this.stateObject.transitionDelay = true;
  }
};

export const handleActiveElemSwitching = elem => {
  elem.classList.remove('isActive');
  elem.ariaHidden = 'true';
  elem.tabIndex = '-1';
};

export const handleActiveElemSetting = (elem, $this, isElemFocusReqd = true) => {
  if (elem) {
    elem.classList.add('isActive');
    elem.ariaHidden = 'false';
    elem.tabIndex = '0';
    if (isElemFocusReqd && $this.stateObject.isUsingKeyboard) {
      elem.focus({ preventScroll: true });
    }
  }
};

export const getNextAvailableSiblings = nextSib => {
  const nextSiblingArr = [];
  while (nextSib) {
    if (nextSib) {
      nextSiblingArr.push(nextSib);
    }
    nextSib = nextSib.nextElementSibling;
  }
  return nextSiblingArr;
};

export const disablePrevBtnOnFirstSlide = $this => {
  if ($this.stateObject.slideIndex === 0) {
    $this.showPrev = false;
  }
};

export const handlePrevSlide = ($this, updateTransformWidth) => {
  if ($this.stateObject.isTransitionStarted || !$this.showPrev) {
    return;
  }

  $this.stateObject.fsDelay = false;
  $this.stateObject.isPrev = true;
  $this.stateObject.isNext = false;
  $this.stateObject.transitionEffect = 'ease';
  const currentActiveElem = $this.fsWrapper.querySelector('.isActive');
  $this.slideWidth = currentActiveElem.previousElementSibling.clientWidth;

  if ($this.loop) {
    resetListElemAccessibility($this);
    $this.stateObject.showPrev = true;
    if (currentActiveElem) {
      handlePrevSlideLoop($this, currentActiveElem);
      $this.stateObject.slideIndex = $this.slideIndex - 1;
      $this.currentTransformWidth -= currentActiveElem.previousElementSibling.clientWidth;
      updateTransformWidth($this.currentTransformWidth);
      handleActiveElemSwitching(currentActiveElem);
    }
  } else {
    $this.stateObject.transitionDelay = false;
    const prevSibling = currentActiveElem.previousElementSibling;
    if ($this.stateObject.slideIndex > 0) {
      $this.stateObject.slideIndex -= 1;
      $this.currentTransformWidth -= prevSibling.clientWidth;
    }
    $this.stateObject.transitionEffect = 'ease';
    $this.stateObject.showPrev = $this.slideIndex !== 0;
    handleActiveElemSwitching(currentActiveElem);
    handleActiveElemSetting(prevSibling, $this);
    disablePrevBtnOnFirstSlide($this);
  }
  $this.showNext = true;
};

export const handleNextSlide = ($this, updateTransformWidth) => {
  if ($this.stateObject.isTransitionStarted || !$this.showNext) {
    return;
  }
  $this.swiped = 0;
  $this.stateObject.isPrev = false;
  $this.stateObject.isNext = true;
  $this.stateObject.fsDelay = false;
  $this.stateObject.transitionEffect = 'ease';
  const currentActiveElem = $this.fsWrapper.querySelector('.isActive');
  $this.slideWidth = currentActiveElem.nextElementSibling.clientWidth;
  if ($this.loop) {
    resetListElemAccessibility($this);
    if (currentActiveElem) {
      handleNextSlideLoop($this, currentActiveElem);
      $this.stateObject.slideIndex = $this.stateObject.slideIndex + 1;
      $this.currentTransformWidth += currentActiveElem.clientWidth;
      updateTransformWidth($this.currentTransformWidth);
      handleActiveElemSwitching(currentActiveElem);
    }
    $this.showNext = true;
    $this.showPrev = true;
  } else {
    $this.showPrev = true;
    $this.stateObject.transitionDelay = false;
    $this.stateObject.slideIndex = $this.stateObject.slideIndex + 1;
    $this.currentTransformWidth += currentActiveElem.clientWidth;
    const nextSibling = currentActiveElem.nextElementSibling;
    $this.showNext = $this.stateObject.slideIndex === $this.stateObject.numItems - 1 ? false : true;
    handleActiveElemSwitching(currentActiveElem);
    handleActiveElemSetting(nextSibling, $this);
    resetListElemAccessibility($this);
    $this.stateObject.isSwiping = false;
  }
};

export const delayFocusWhenTransitionSwitch = $this => {
  setTimeout(() => {
    $this.fsWrapper.querySelector('.isActive').focus({ preventScroll: true });
  }, 0);
};

export const handleTransitionOver = $this => {
  $this.stateObject.transitionEffect = 'none';
  $this.stateObject.isTransitionStarted = false;
  if ($this.stateObject.transitionDelay && ($this.stateObject.isNext || $this.stateObject.isPrev)) {
    $this.stateObject.slideIndex = $this.stateObject.isNext ? $this.stateObject.firstItemIndex : $this.stateObject.lastItemIndex;
    $this.stateObject.fsDelay = true;
    $this.currentTransformWidth = getTransformWidth($this, 0, $this.stateObject.slideIndex);
    $this.stateObject.transitionDelay = false;
    if ($this.stateObject.isUsingKeyboard) {
      delayFocusWhenTransitionSwitch($this);
    }
  }
};

export const formatCaptionData = $this => {
  const captionDataObj = {};
  const filmstripImages = $this.stateObject.slidesData;
  let isCaptionDataAvailable = false;
  if (filmstripImages) {
    filmstripImages.forEach((val, i) => {
      if(val?.imgCaption){
        isCaptionDataAvailable = true;
      }
      captionDataObj[i] = val.imgCaption || '';
    });
  }
  $this.isCaptionDataAvailable = isCaptionDataAvailable;
  return captionDataObj;
};

export const generateRandomId = () => {
  const crypto = window.crypto;
  const array = new Uint32Array(1);
  const uniqueNumArr = crypto.getRandomValues(array);
  return uniqueNumArr[0];
};

export const toggleHideShowBtn = $this => {
  const containerWidth = $this.stateObject.wrapperWidth;
  const liSelector = $this.fsWrapper.querySelector('li');
  let liWidth = 0;
  if (liSelector) {
    liWidth = $this.stateObject.numItems * liSelector.clientWidth;
  }
  if (liWidth > containerWidth) {
    $this.showNext = true;
  } else {
    $this.showNext = false;
  }
};

export const setDimensionParams = $this => {
  $this.stateObject.wrapperWidth = window.innerWidth;
  const liSelector = $this.fsWrapper.querySelector('.isActive');
  if (liSelector) {
    $this.slideWidth = liSelector.clientWidth;
  }
  //toggleHideShowBtn($this);
  if ($this.loop) {
    $this.currentTransformWidth = getTransformWidth($this, 0, $this.stateObject.slideIndex);
  }
};

export const getTransformWidth = ($this, startSlide, targetSlide) => {
  const liElemsToSlide = Array.from($this.fsWrapper.querySelectorAll('li')).slice(startSlide, targetSlide) || [];
  let toSlide = 0;
  if (liElemsToSlide.length) {
    liElemsToSlide.forEach((liVal: any) => {
      toSlide += liVal.clientWidth;
    });
  }
  return toSlide;
};

export const renderCaptionData = $this => {
  const currentActiveElem = ($this.fsWrapper && $this.fsWrapper.querySelector('.isActive')) || null;
  const currentActiveElemIndex = currentActiveElem && currentActiveElem.dataset.index;
  $this.slideWidth = currentActiveElem?.clientWidth;
  $this.stateObject.activeElementIndex = currentActiveElemIndex || 0;
  return (currentActiveElemIndex && $this.originalArray[currentActiveElemIndex]['imgCaption']) || '';
};

export const onResize = (e, $this) => {
  $this.wrapperWidth = e.target.innerWidth;
  $this.stateObject.transitionEffect = 'none';
  const allLiElements = $this.fsWrapper.querySelectorAll('li');
  $this.currentTransformWidth = getTransformWidth($this, 0, $this.stateObject.slideIndex) || 0;
  $this.slideWidth = allLiElements[$this.stateObject.slideIndex].clientWidth;
  toggleHideShowBtn($this);
};
